import React from "react";
import { Outlet } from "react-router-dom";
import ClientPortalSectionShell from "../components/clientPortal/ClientPortalSectionShell";
import { CLIENT_PORTAL_PRIMARY_NAV } from "../clientPortal/clientPortalPrimaryNav";

const RESOURCES_SUB_NAV = [
  { to: "/client-portal/resources", label: "Overview", end: true },
  { to: "/client-portal/resources/calculators", label: "Numbers" },
  { to: "/client-portal/resources/links", label: "Professional tools" },
];

export default function ClientResourcesLayout() {
  return (
    <ClientPortalSectionShell
      navLabel="Portal navigation"
      items={CLIENT_PORTAL_PRIMARY_NAV}
      subItems={RESOURCES_SUB_NAV}
      subItemsLabel="In resources"
    >
      <Outlet />
    </ClientPortalSectionShell>
  );
}
